export enum ProcessMachineLearningType {
  ProcessAll = 'ProcessAll',
  ProcessNew = 'ProcessNew',
}
